import zh from './locales/zh';
import en from './locales/en';
import es from './locales/es';
import pt from './locales/pt';

// 支持的语言列表
export const supportedLanguages = ['zh', 'en', 'es', 'pt'];

// 默认语言
export const defaultLanguage = 'en';

// 所有翻译
const translations = {
  zh,
  en,
  es,
  pt,
};

/**
 * 获取翻译对象
 * @param {string} lang - 语言代码
 * @returns {object} 翻译对象
 */
export function getTranslations(lang) {
  // 如果语言不支持，返回默认语言
  if (!supportedLanguages.includes(lang)) {
    return translations[defaultLanguage];
  }
  return translations[lang] || translations[defaultLanguage];
}

/**
 * Hook for using translations in components
 * @param {string} lang - 语言代码
 * @returns {object} { t: function } - 翻译函数
 */
export function useTranslation(lang) {
  const translations = getTranslations(lang);
  
  const t = (key) => {
    return translations[key] || key;
  };
  
  return { t };
}

